import { arrayEquals } from '../helpers/utilities';
import addToCart from '../modules/addToBag';

interface IConfig {
  variants: IVariant[],
  className: IClassName,
  selectors: ISelectors,
  options: string[]
}

interface IVariant {
  id: number,
  available: boolean,
  options: string[],
  [keyof:string]:any
}

interface IClassName {
  selected: string
}

interface ISelectors {
  productOption: string
}

class ProductOptions {
  
  private config:IConfig

  constructor() {
    this.config = {
      options: null,
      variants: window.theme.variants,
      selectors: {
        productOption: '[data-product-option]',
      },
      className: {
        selected: 'product-options__value--selected'
      }
    };
  }

  init() {
    if (!this.config.variants) return;
    if (window.theme.productOptions.firstAvailableVariant) this.config.options = window.theme.productOptions.firstAvailableVariant.options;
    if (this.config.options && this.config.variants.length > 1) {
      this.selectOptions(this.config.options);
      window.addEventListener('click', this.handleClick.bind(this));
    }
  }

  selectOptions(options:string[]) {
    options.forEach(option => {
      document.querySelector(`[data-product-option-value="${ option }"]`).classList.add(this.config.className.selected);
    });
  }
  
  handleClick(event:Event) {
    const target = event.target as HTMLElement;
    const position = parseInt(target.dataset.productOptionPosition);
    const options = document.querySelectorAll(this.config.selectors.productOption);
    const selectedOptions = this.getSelectedOptions(options, position, target);
    const variant = this.getCurrentVariant(selectedOptions);
    const enabled = (variant !== undefined && variant.available);
    this.clearOptions();
    this.selectOptions(selectedOptions);
    addToCart.enabled(enabled, variant);
    addToCart.updateVariant(variant);
  }

  getCurrentVariant(selectedOptions:string[]) {
    return this.config.variants.find(variant => {
      return arrayEquals(variant.options, selectedOptions);
    });
  }

  clearOptions() {
    const options = document.querySelectorAll(this.config.selectors.productOption);
    options.forEach(option => option.classList.remove(this.config.className.selected));
  }

  getSelectedOptions(options:NodeList, position?:number, target?:HTMLElement):any {
    return Array.from(options).filter((option:HTMLElement) => {
      return option.classList.contains(this.config.className.selected);
    }).reduce((acc, option:HTMLElement, index:number) => {
      let value = option.dataset.productOptionValue;
      if (index === position) value = target.dataset.productOptionValue;
      acc.push(value);
      return acc;
    }, []);
  }
}

export default new ProductOptions();